/**
 * logo-marquee.js
 * Handles Slick Slider init and Marquee ticker behavior
 * for the Shopify Logo Marquee section.
 */

(function () {
  'use strict';

  /**
   * Wait for both jQuery and Slick to be available, then init.
   * Uses a short polling interval to handle deferred script loading.
   */
  function waitForSlick(callback, maxWait) {
    var waited = 0;
    var interval = setInterval(function () {
      waited += 50;
      if (typeof window.jQuery !== 'undefined' && typeof window.jQuery.fn.slick !== 'undefined') {
        clearInterval(interval);
        callback();
      } else if (waited >= maxWait) {
        clearInterval(interval);
        console.warn('[LogoMarquee] Slick not loaded after ' + maxWait + 'ms.');
      }
    }, 50);
  }

  /* ──────────────────────────────────────────────────
     SLICK SLIDER INIT
  ────────────────────────────────────────────────── */

  function initSliders() {
    document.querySelectorAll('.logo-marquee__slider').forEach(function (el) {
      if (el.dataset.slickInit === 'true') return; // prevent double-init

      var $ = window.jQuery;
      var $slider = $(el);
      var config = {};

      try {
        config = JSON.parse(el.dataset.slick || '{}');
      } catch (e) {
        console.warn('[LogoMarquee] Invalid data-slick JSON on', el);
      }

      // Attach custom prev/next arrows from sibling buttons
      var wrap = el.closest('.logo-marquee__slider-wrap');
      if (wrap) {
        var prevBtn = wrap.querySelector('.logo-marquee__arrow--prev');
        var nextBtn = wrap.querySelector('.logo-marquee__arrow--next');
        if (prevBtn && nextBtn) {
          config.prevArrow = prevBtn;
          config.nextArrow = nextBtn;
          // Ensure slick doesn't hide them
          config.arrows = true;
        }
      }

      $slider.slick(config);

      // Mark as initialized
      el.dataset.slickInit = 'true';
    });
  }

  /* ──────────────────────────────────────────────────
     MARQUEE TICKER
  ────────────────────────────────────────────────── */

  function initMarquees() {
    document.querySelectorAll('.logo-marquee__ticker-wrap').forEach(function (wrap) {
      var direction = wrap.dataset.direction || 'left';
      var pauseOnHover = wrap.dataset.pauseOnHover === 'true';

      // Pause / resume on hover
      if (pauseOnHover) {
        wrap.addEventListener('mouseenter', function () {
          wrap.querySelectorAll('.logo-marquee__ticker-track').forEach(function (track) {
            track.style.animationPlayState = 'paused';
          });
        });
        wrap.addEventListener('mouseleave', function () {
          wrap.querySelectorAll('.logo-marquee__ticker-track').forEach(function (track) {
            track.style.animationPlayState = 'running';
          });
        });
      }

      // Touch: pause while dragging (nice on mobile)
      var touchStartX = 0;
      wrap.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        wrap.querySelectorAll('.logo-marquee__ticker-track').forEach(function (track) {
          track.style.animationPlayState = 'paused';
        });
      }, { passive: true });

      wrap.addEventListener('touchend', function () {
        wrap.querySelectorAll('.logo-marquee__ticker-track').forEach(function (track) {
          track.style.animationPlayState = 'running';
        });
      }, { passive: true });
    });
  }

  /* ──────────────────────────────────────────────────
     SHOPIFY THEME EDITOR SUPPORT
     Re-initialise after section:load / block:select
  ────────────────────────────────────────────────── */

  function onSectionLoad(event) {
    var section = event.target || document.getElementById(event.detail && event.detail.sectionId ? 'logo-marquee-' + event.detail.sectionId : '');
    if (!section) return;

    // Re-init slider inside the re-loaded section
    section.querySelectorAll('.logo-marquee__slider').forEach(function (el) {
      el.dataset.slickInit = '';
    });

    if (section.querySelector('.logo-marquee__slider')) {
      waitForSlick(initSliders, 3000);
    }

    if (section.querySelector('.logo-marquee__ticker-wrap')) {
      initMarquees();
    }
  }

  /* ──────────────────────────────────────────────────
     BOOT
  ────────────────────────────────────────────────── */

  function boot() {
    var hasSlider = document.querySelector('.logo-marquee__slider');
    var hasMarquee = document.querySelector('.logo-marquee__ticker-wrap');

    if (hasSlider) {
      waitForSlick(initSliders, 5000);
    }

    if (hasMarquee) {
      initMarquees();
    }

    // Shopify Theme Editor events
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', onSectionLoad);
      document.addEventListener('shopify:section:reorder', onSectionLoad);
    }
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
